import memoizee from 'memoizee';
export var memoize = memoizee;